import { makeAutoObservable } from 'mobx';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { FilterStore } from '../../shared/util-stores';
import {
  CoachListFilters,
  CoachListFormValues,
} from '../interfaces/coach-list/CoachListFilters';
import { CoachRowInfo } from '../interfaces/coach-list/CoachRowInfo';
import { coachService } from '../services/coachService';
import { HandleGetDataReturn } from '../../shared/util-stores/FilterStore/FilterStore';
import { SOLUTION_TYPE } from '../../shared/constants/user-info/solutionType';

// not export if need to use use defaultFilterData from filterMethods
const defaultFilters: CoachListFormValues = {
  commissionRenew: '',
  commissionSetUp: '',
  entityAddress: '',
  entityCity: '',
  entityId: '',
  name: '',
  page: '',
  state: '',
  zip: '',
  withSolutionType: '',
};

class CoachListStore {
  coachList: CoachRowInfo[] = [];
  filterMethods: FilterStore<CoachListFormValues>;

  constructor(defaultFilterData: CoachListFormValues) {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<CoachListFormValues>(this.handleGetCoachList, {
      defaultFilterData,
    });
  }

  setDefaultValues() {
    this.coachList = [];
    this.filterMethods.setDefaultValues();
  }

  private async handleGetCoachList(
    filterInfo: CoachListFilters,
  ): Promise<HandleGetDataReturn> {
    const data = await coachService.getCoachList(filterInfo);
    const { items, page } = data;

    this.setCoachList(items);

    return {
      totalPages: page.count,
      number: page.currentPage,
      content: items,
      totalElements: page.count * page.limit, // NOT CORRECT COMPLETELY
    };
  }

  async getCoachList() {
    return this.filterMethods.getData();
  }

  private setCoachList(coachList: CoachRowInfo[]) {
    this.coachList = coachList;
  }
}

const nutritionCoachListStore = new CoachListStore({
  ...defaultFilters,
  withSolutionType: SOLUTION_TYPE.NUTRITION,
});
const scanIQCoachListStore = new CoachListStore({
  ...defaultFilters,
  withSolutionType: SOLUTION_TYPE.SCAN_IQ,
});

resetAllStore.addResetMethod(nutritionCoachListStore.setDefaultValues);
resetAllStore.addResetMethod(scanIQCoachListStore.setDefaultValues);

export { nutritionCoachListStore, scanIQCoachListStore, CoachListStore };
